import Grid from '@/global/components/ui/Grid'
import dayjs from 'dayjs'
import { FormDatePicker } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { centroCustoFuncionario_api, funcionario } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { FormAutocompleteCentroCusto } from 'templates/Cadastro/CentroCusto/atoms/modals/Adicionar'
import { z } from 'zod'

const schema = z.object({
    FuncionarioCentroCusto: z.object({
        CentroCusto: z.object(
            { id: z.number() },
            {
                required_error: 'Campo obrigatório',
                invalid_type_error: 'Campo obrigatório',
            },
        ),
        dtInicial: z.any().refine(Boolean, 'Campo obrigatório'),
        dtFinal: z.any().nullish(),
    }),
})

interface Props {
    open: boolean
    onClose: () => void
}

/** Vincula um centro de custo ao funcionário, salvando direto na API. */
export function AdicionarCentroCustoFuncionario({ open, onClose }: Props) {
    const funcionarioId = useStore(state => state.employeeId)
    const { mutateAsync, isLoading } =
        centroCustoFuncionario_api.mutations.useCreate()

    function handleSubmit({
        FuncionarioCentroCusto: vinculo,
    }: z.infer<typeof schema>) {
        return mutateAsync(
            {
                centroCustoId: vinculo.CentroCusto.id,
                dtInicial: dayjs(vinculo.dtInicial).toDate(),
                dtFinal: vinculo.dtFinal
                    ? dayjs(vinculo.dtFinal).toDate()
                    : null,
                funcionarioId,
            },
            {
                onSuccess: async () => {
                    toast.success('Centro de custo adicionado com sucesso', {
                        description:
                            'As informações já foram salvas, não é necessário clicar em Salvar.',
                    })
                    await Promise.all([
                        centroCustoFuncionario_api.invalidateQueries(),
                        funcionario.invalidateQueries(),
                    ])
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            open={hasPermission(['update', 'Funcionários']) && open}
            onClose={onClose}
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={schema}
        >
            <Dialog.Title>Associar centro de custo</Dialog.Title>
            <Dialog.Content>
                <Grid container>
                    <Grid item xs={12}>
                        <FormAutocompleteCentroCusto />
                    </Grid>
                    <Grid item xs={6}>
                        <FormDatePicker
                            name="FuncionarioCentroCusto.dtInicial"
                            label="Data inicial"
                            type="date"
                            required
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormDatePicker
                            name="FuncionarioCentroCusto.dtFinal"
                            label="Data final"
                            type="date"
                            helperText="Deixe em branco para indeterminado"
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
